import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useShop(shopId: string) {
    const { data } = useQuery({
        ...queries.shop.detail(shopId),
        enabled: !!shopId,
    });

    return data;
}

export default useShop;
